import React, { useEffect, useRef, useState } from "react";
import IMultiFactorAuth from "./IMultiFactorAuth";
import { Space } from "antd";

import * as style from "./MultiFactorAuthStyle.module.scss";
import * as elements from "@appStyles/_elements.module.scss";

const isNumber = new RegExp("^[0-9]+$");

const MultiFactorAuth: React.SFC<IMultiFactorAuth> = (props) => {
  const refs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
  ];

  const [recoveryCodeState, setRecoveryCodeState] = useState(false);
  const [currentRefState, setCurrentRefState] = useState(refs[0]);
  const [resultState, setResultState] = useState("");

  useEffect(() => {
    currentRefState.current!.focus();
    currentRefState.current!.value = "";
  }, [currentRefState]);

  const handleClick = (ref: React.RefObject<HTMLInputElement>) => {
    const index = refs.indexOf(ref);
    setCurrentRefState(refs[index]);
    ref.current!.value = "";
    const part1 = resultState.substring(0, index);
    const part2 = resultState.substring(index + 1, resultState.length);
    setResultState(part1 + part2);
  };

  const handleNavigation = (e: React.KeyboardEvent<HTMLInputElement>) => {
    checkIfBack(e);
    checkIfForward(e);
  };

  const checkIfBack = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (currentRefState === refs[0]) {
      return;
    }
    if (e.keyCode === 8 || e.keyCode === 46) {
      setResultState(produceResult);
      currentRefState.current!.value = "";
      setCurrentRefState((prevState) => refs[refs.indexOf(prevState) - 1]);
    }
  };

  const checkIfForward = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const index = refs.indexOf(currentRefState);

    if (e.keyCode === 9) {
      setCurrentRefState(index + 1 < 7 ? refs[index + 1] : refs[7]);
    }
  };

  const submitCode = (code?: string) => {
    if (code) {
      fillInputs(code);
      setTimeout(() => {
        props.submit(code.slice(0, 8));
      }, 300);
      return;
    }
    if (refs) {
      const result = produceResult();
      setResultState(result);
      setTimeout(() => {
        props.submit(result);
      }, 300);
    }
  };

  const fillInputs = (providedString: string) => {
    refs.forEach(
      (ref, i) => ref.current && (ref.current.value = providedString[i] || "")
    );
  };

  const produceResult = () => {
    let value = "";
    refs.forEach((el) => (value += el.current ? el.current.value : ""));
    return value;
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.stopPropagation();
    e.preventDefault();
    const clipboardData = e.clipboardData;
    const pastedData = clipboardData.getData("Text").trim();
    if (isNumber.test(pastedData)) {
      setRecoveryCodeState(pastedData.length >= 8);
      refs[0].current!.blur();
      setResultState(pastedData);
      submitCode(pastedData);
    } else {
      alert(`Code should contain only digits, You've pasted: "${pastedData}"`);
    }
  };

  const handleChange = () => {
    if (!isNumber.test(currentRefState.current!.value)) {
      currentRefState.current!.value = "";
      return;
    }
    if (
      (currentRefState === refs[5] && !recoveryCodeState) ||
      (currentRefState === refs[7] && recoveryCodeState)
    ) {
      submitCode();
      return;
    }
    const nextEmpty = refs.find((ref) => ref.current!.value === "");
    if (currentRefState.current!.value !== "" && nextEmpty) {
      setCurrentRefState(nextEmpty);
    }
    setResultState(produceResult);
  };

  const toggleRecovery = () => {
    fillInputs("");
    setResultState("");
    setRecoveryCodeState(!recoveryCodeState);
  };

  return (
    <div className={style.multiFactorAuth}>
      <div className={!recoveryCodeState ? style.hideTwo : ""}>
        {refs.map((ref, i) => {
          return (
            <input
              data-cy={`2fa-field-input-${i}`}
              className={style.multiInput}
              maxLength={1}
              ref={ref}
              onKeyDown={handleNavigation}
              onChange={handleChange}
              key={i}
              onPaste={handlePaste}
              onClick={() => handleClick(ref)}
              type="text"
            />
          );
        })}
      </div>
      {props.showButton && (
        <div className={[style.validateButton].join(" ")}>
          <button
            onClick={() => {
              props.submit(resultState);
            }}
            disabled={
              recoveryCodeState
                ? resultState.length <= 7
                : resultState.length <= 5
            }
            className={elements.btn}
          >
            Validate
          </button>
        </div>
      )}

      <Space style={{ marginTop: "20px" }}>
        {!recoveryCodeState && (
          <p
            className={[style.description, style.descriptionRecovery].join(" ")}
          >
            Problems with device?
          </p>
        )}
        <span
          className={[style.toggleCodeType].join(" ")}
          onClick={toggleRecovery}
        >
          {recoveryCodeState ? "Back to standard code" : "Use recovery code"}
        </span>
      </Space>
    </div>
  );
};

export default MultiFactorAuth;
